import { Message } from 'element-ui'
import router from './router'
import { guard, handleError } from './scripts/guard'
import api from './scripts/api'
import { logout } from './scripts/account'

const install = Vue => {
  let plugins = {
    $appName: process.env.VUE_APP_NAME,
    $api: api,
    $guard: guard,
    $handleError: handleError,
    $copyrights: [{ name: '合心科技', link: 'http://www.hexinedu.com' }],
    $icps: ['京ICP备14033449号'],
    $goLogin () {
      logout()
      router.push('/login')
      Message.success('登出成功')
    },
  }

  Object.assign(Vue.prototype, plugins)

  Vue.prototype.$validate = function (form, prop) {
    if (prop) return new Promise(resolve => form.validateField(prop, resolve))
    return new Promise(resolve => form.validate(resolve))
  }

  Object.defineProperty(Vue.prototype, '$query', {
    get () {
      return this.$route.query
    },
  })

  Vue.prototype.$updateQuery = function (...queries) {
    this.$dontReload = true
    this.$router.replace({ query: Object.assign({}, this.$route.query, ...queries) })
    setTimeout(() => this.$dontReload = false, 0)
  }

  if (process.env.NODE_ENV === 'development') {
    Object.assign(window, plugins)
    window.Vue = Vue
  }
}

export default { install }
